export { default } from "./InsightsLayout";
